import React, { useContext } from "react";
import InfoMessageContext from "../contexts/InfoMessageContext";
import type { InfoMessage, InfoMessageType } from "providers/InfoMessageProvider/InfoMessageProvider";

function useInfoMessageStore() {
  return useContext(InfoMessageContext);
}

interface UseInfoMessageProps {
  type: InfoMessageType;
}

interface ModifiedInfoMessage extends Omit<InfoMessage, "type"> {}

function useInfoMessage(props: UseInfoMessageProps) {
  const { type } = props;
  const setInfoMessage = useInfoMessageStore();

  const modifiedSetInfoMessage = React.useCallback(
    (info: ModifiedInfoMessage) => {
      setInfoMessage?.(info, type);
    },
    [setInfoMessage, type]
  );

  return modifiedSetInfoMessage;
}
export default useInfoMessage;
